import { Record, Set, fromJS, List } from "immutable";
import { ZONE_TYPES } from "src/infinode/constants/zone";
import DataSourceRecord from "./DataSourceRecord";
import DataSourceValueRecord from "./DataSourceValueRecord";

const ZoneRecord = Record({
  id: null,
  key: null,
  name: null,
  description: "",
  circuits: Set(),
  dataSource: DataSourceRecord(),
  isActive: false,
  zoneType: ZONE_TYPES.NEITHERORCONSUMER,
  // demand
  demandOn: false,
  DLCId:null,
  meters:[],
  allowedDemand:null,
  ratedPV:null
});

const createZoneRecord = zone => {
  return ZoneRecord(zone).withMutations(zm => {
    zm.update("name", n => n || "");
    zm.update("description", d => d || "");
    zm.set(
      "dataSource",
      DataSourceRecord(
        zone.dataSource
          ? fromJS(zone.dataSource).map(ds => (ds ? List(ds.map(v => DataSourceValueRecord(v))) : List()))
          : List()
      )
    );
    zm.update("circuits", cs => cs || Set());
    if (zone.zoneDemand) {
      zm.set("demandOn", zone.zoneDemand.isOn);
    }
  });
};

export { createZoneRecord };

export default ZoneRecord;
